import { render } from "./BreadcrumbMenu.vue?vue&type=template&id=0493da49&scoped=true"
import script from "./BreadcrumbMenu.vue?vue&type=script&lang=js"
export * from "./BreadcrumbMenu.vue?vue&type=script&lang=js"

import "./BreadcrumbMenu.vue?vue&type=style&index=0&id=0493da49&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0493da49"],['__file',"src/common/components/layout/BreadcrumbMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0493da49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0493da49', __exports__)) {
    api.reload('0493da49', __exports__)
  }
  
  module.hot.accept("./BreadcrumbMenu.vue?vue&type=template&id=0493da49&scoped=true", () => {
    api.rerender('0493da49', render)
  })

}


export default __exports__